
//<---------------------DOMAIN ITEMS--------------------->
// register .SK = domainItems[0]
// register .COM = domainItems[1]
// register .CZ = domainItems[2]
// register .NO = domainItems[3]
// register .HU = domainItems[4]
// transfer .HU = domainItems[5]

/* eslint-disable sonarjs/no-duplicate-string */
export const domainItemsMock = [
  {
    id: 4575684,
    code: 'domain-register',
    period: 12,
    prolongPeriod: 12,
    sellType: 'direct',
    properties: {
      domain: 'frfrfrfrfrfr.sk',
      premium: false,
      tld: 'sk'
    },
    options: {
      period: [
        {
          period: 12,
          price: 9.9,
          onlyCardPayment: false
        },
        {
          period: 24,
          price: 26.8,
          onlyCardPayment: false
        },
        {
          period: 36,
          price: 43.7,
          onlyCardPayment: false
        },
        {
          period: 48,
          price: 60.6,
          onlyCardPayment: false
        },
        {
          period: 60,
          price: 77.5,
          onlyCardPayment: false
        },
        {
          period: 72,
          price: 94.4,
          onlyCardPayment: false
        },
        {
          period: 84,
          price: 111.3,
          onlyCardPayment: false
        },
        {
          period: 96,
          price: 128.2,
          onlyCardPayment: false
        },
        {
          period: 108,
          price: 145.1,
          onlyCardPayment: false
        },
        {
          period: 120,
          price: 162,
          onlyCardPayment: false
        }
      ]
    },
    price: {
      vatExcluded: 9.9,
      discountReason: null,
      originalPrice: null
    },
    coupon: null,
    mandatoryEditableProperties: [],
    optionalEditableProperties: [
      'domainProfileId'
    ],
    mossFlow: [],
    settings: [],
    removable: true,
    prolongPrice: {
      vatExcluded: 16.9,
      discountReason: null,
      originalPrice: 16.9
    },
    gaee: {
      id: 'sk-domain-registration',
      name: 'SK Domain Registration',
      categories: [
        'Domain',
        'Domain Registration'
      ],
      brand: 'Websupport',
      price: 9.9,
      quantity: 1,
    }
  },
  {
    id: 23898,
    code: 'domain-register',
    period: 12,
    sellType: 'direct',
    removable: true,
    properties: {
      domainProfileId: null,
      domain: 'ododododododo.com',
      premium: false,
      tld: 'com',
    },
    options: {
      period: [
        {
          period: 12,
          price: 3690,
          onlyCardPayment: false,
        },
      ],
    },
    price: {
      vatExcluded: 3690,
      discountReason: null,
      originalPrice: null,
    },
    coupon: null,
    mandatoryEditableProperties: [],
    optionalEditableProperties: ['domainProfileId'],
    mossFlow: [],
    gaee: {
      id: 'com-domain-registration',
      name: 'COM Domain Registration',
      categories: ['Domain','Domain Registration'],
      brand: 'Websupport',
      price: '3690.00',
      quantity: 1,
    },
    prolongPrice: {
      vatExcluded: 3690,
      discountReason: null,
      originalPrice: 3690,
    },
  },
  {
    id: 23904,
    code: 'domain-register',
    period: 12,
    sellType: 'direct',
    removable: true,
    properties: {
      domainProfileId: null,
      domain: 'czczczczczczc.cz',
      premium: false,
      tld: 'cz',
    },
    options: {
      period: [
        {
          period: 12,
          price: 4200,
          onlyCardPayment: false,
        },
      ],
    },
    price: {
      vatExcluded: 4200,
      discountReason: null,
      originalPrice: null,
    },
    coupon: null,
    mandatoryEditableProperties: [],
    optionalEditableProperties: ['domainProfileId'],
    mossFlow: [],
    gaee: {
      id: 'cz-domain-registration',
      name: 'CZ Domain Registration',
      categories: ['Domain','Domain Registration'],
      brand: 'Websupport',
      price: '4200.00',
      quantity: 1,
    },
    prolongPrice: {
      vatExcluded: 4200,
      discountReason: null,
      originalPrice: 4200,
    },
  },
  {
    id: 23907,
    code: 'domain-register',
    period: 12,
    sellType: 'direct',
    removable: true,
    properties: {
      domainProfileId: null,
      domain: 'nononononono.no',
      premium: false,
      tld: 'store',
    },
    options: {
      period: [
        {
          period: 12,
          price: 1990,
          onlyCardPayment: false,
        },
      ],
    },
    price: {
      vatExcluded: 1990,
      discountReason: null,
      originalPrice: null,
    },
    coupon: null,
    mandatoryEditableProperties: [],
    optionalEditableProperties: ['domainProfileId'],
    mossFlow: [],
    gaee: {
      id: 'store-domain-registration',
      name: 'STORE Domain Registration',
      categories: ['Domain','Domain Registration'],
      brand: 'Websupport',
      price: '1990.00',
      quantity: 1,
    },
    prolongPrice: {
      vatExcluded: 15500,
      discountReason: null,
      originalPrice: 15500,
    },
  },
  {
    id: 23910,
    code: 'domain-register',
    period: 12,
    sellType: 'direct',
    removable: true,
    properties: {
      domainProfileId: null,
      domain: 'uhuhuhuhuhuhuhuh.hu',
      premium: false,
      tld: 'online',
    },
    options: {
      period: [
        {
          period: 12,
          price: 1490,
          onlyCardPayment: false,
        },
      ],
    },
    price: {
      vatExcluded: 1192,
      discountReason: 'bundle',
      originalPrice: 1490,
    },
    coupon: null,
    mandatoryEditableProperties: [],
    optionalEditableProperties: ['domainProfileId'],
    mossFlow: [],
    gaee: {
      id: 'online-domain-registration',
      name: 'ONLINE Domain Registration',
      categories: ['Domain','Domain Registration'],
      brand: 'Websupport',
      price: '1490.00',
      quantity: 1,
    },
    prolongPrice: {
      vatExcluded: 9300,
      discountReason: null,
      originalPrice: 9300,
    },
  },
  {
    id: 23886,
    code: 'domain-transfer',
    period: 12,
    sellType: 'direct',
    removable: true,
    properties: {
      domainProfileId: null,
      domain: 'huhuhuhuhuhuhu.hu',
      premium: false,
      tld: 'hu',
    },
    options: {
      period: [
        {
          period: 12,
          price: 1350,
          onlyCardPayment: false,
        },
      ],
    },
    price: {
      vatExcluded: 1350,
      discountReason: null,
      originalPrice: null,
    },
    coupon: null,
    mandatoryEditableProperties: [],
    mossFlow: [],
    optionalEditableProperties: ['domainProfileId', 'eppCode'],
    gaee: {
      id: 'hu-domain-registration',
      name: 'HU Domain Registration',
      categories: ['Domain','Domain Registration'],
      brand: 'Websupport',
      price: '1350.00',
      quantity: 1,
    },
    prolongPrice: {
      vatExcluded: 1350,
      discountReason: null,
      originalPrice: 1350,
    },
  },
];
